const routes = [
    {
        path: "/dashboard",
        component: () => import("../pages/Index"),
        meta: { isAuthenticated: true },
        component_full_path: 'dashboard/pages/Index.vue'
    },

];

export default routes;
